import type { FaireProductEntity } from "../../entity_types/product";

export const p_sydx2kr3c6: FaireProductEntity = {
  token: "p_sydx2kr3c6",
  type: "product",
  name: "Just Ice Tea, 12oz Cans",
  brandToken: "b_47s98587ya",
  brandName: "Oasis Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/da707309a73f499965d352d1bf42c4d699f02a5602c070c3fa63c351ebb1bc32.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b754e3d74b80048df843e37f438e911f062d2c4dc1440895495ff6b2e32cc20d.png",
    "https://cdn.faire.com/fastly/8c991337e89adb3c21012d26988c36a32f2f5b7ee65366607e97cae2ad15044e.png",
    "https://cdn.faire.com/fastly/ffb0e3339d1c4c2e1b0a7d5a2c15e9fee7c4ace7552488466d4218425616318e.png",
    "https://cdn.faire.com/fastly/83647043370674731cc6d7decdcbf91f850d2185f9b57c4bfea29aa8b540e455.jpeg",
    "https://cdn.faire.com/fastly/95ee96979c604bd9e8cbe78edf01c00dff90e958144de7116117d86cc802c309.jpeg",
  ],
  priceDollars: 2.88,
  description:
    "Our line of delicious, organic and Fair Trade Certified™ bottled teas has something for JUST about anyone . Now in 12oz cans!",
  tags: [],
  msrpDollars: 5.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:32.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
